import {
  Anchor,
  Box,
  Button,
  Card,
  CardBody,
  Header,
  Heading,
  Spinner,
  Text,
  TextArea,
  TextInput
} from 'grommet'
import { Close, Send } from 'grommet-icons'
import React, { useEffect, useRef, useState } from 'react'
import LabelText from './LabelText'
import { Constants, GlobalConfig, I18n } from 'galarm-config'
import { useDispatch, useSelector } from 'react-redux'
import { ActionCreators, TaskManager } from 'galarm-shared'
import AppCanvas from './AppCanvas'

const ReportAProblemHeader = ({ onSend, disabled }) => {
  const dispatch = useDispatch()
  return (
    <Header className="header" background="brand" pad="small">
      <Text>{I18n.t('reportAProblem')}</Text>
      <Box direction="row" align="center">
        <Button icon={<Send />} onClick={onSend} disabled={disabled} />
        <Button
          icon={<Close />}
          onClick={() => dispatch(ActionCreators.hideReportAProblemScreen())}
        />
      </Box>
    </Header>
  )
}

const ReportAProblem = () => {
  const dispatch = useDispatch()
  const email = useSelector(state => state.userInfo.email)

  const [feedback, setFeedback] = useState('')
  const [emailId, setEmailId] = useState(email)
  const [searchingFaqs, setSearchingFaqs] = useState(false)
  const [faqResults, setFaqResults] = useState(null)

  const isMounted = useRef(true)
  useEffect(
    () => () => {
      isMounted.current = false
    },
    []
  )

  const onChangeFeedback = event => setFeedback(event.target.value)

  const onChangeEmail = event => setEmailId(event.target.value)

  const submitProblemCore = () => {
    dispatch(
      ActionCreators.createSupportTicket(
        Constants.TICKET_TYPES.PROBLEM_REPORT,
        emailId,
        feedback
      )
    ).then(() => {
      if (emailId !== '') {
        GlobalConfig.firebaseHelpers.updateData(
          GlobalConfig.firebaseHelpers.createRef(`users/${GlobalConfig.uid}`),
          { email: emailId }
        )
      }
    })
    dispatch(ActionCreators.hideReportAProblemScreen())
  }

  const onSend = () => {
    setSearchingFaqs(true)
    TaskManager.addHttpsCloudTask('searchFaqs', { query: feedback })
      .then(result => {
        if (!isMounted.current) return
        const faqs = result?.faqs || []
        setSearchingFaqs(false)
        if (faqs.length === 0) {
          submitProblemCore()
        } else {
          setFaqResults(faqs)
        }
      })
      .catch(() => {
        if (!isMounted.current) return
        setSearchingFaqs(false)
        submitProblemCore()
      })
  }

  const onSubmitAnyway = () => submitProblemCore()

  const onEditProblem = () => setFaqResults(null)

  if (searchingFaqs) {
    return (
      <AppCanvas overflow="auto">
        <ReportAProblemHeader onSend={onSend} disabled />
        <Box align="center" margin="medium" gap="small">
          <Spinner />
          <Heading level={5} margin="none">
            {I18n.t('searchingFaqs')}
          </Heading>
        </Box>
      </AppCanvas>
    )
  }

  if (faqResults !== null) {
    return (
      <AppCanvas overflow="auto">
        <ReportAProblemHeader onSend={onSend} disabled />
        <Card margin="small" background="textBackgroundColor" width="600px">
          <CardBody gap="medium" pad="medium">
            <Heading level={5} margin="none">
              {I18n.t('faqsMayHelp')}
            </Heading>
            <Box gap="xsmall">
              {faqResults.map((item, index) => (
                <Anchor
                  key={item.url || index}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer">
                  {item.title}
                </Anchor>
              ))}
            </Box>
            <Box direction="row" gap="small">
              <Button
                primary
                label={I18n.t('submitProblemAnyway')}
                onClick={onSubmitAnyway}
              />
              <Button label={I18n.t('editProblem')} onClick={onEditProblem} />
            </Box>
          </CardBody>
        </Card>
      </AppCanvas>
    )
  }

  return (
    <AppCanvas overflow="auto">
      <ReportAProblemHeader onSend={onSend} />
      <Card margin="small" background="textBackgroundColor" width="600px">
        <CardBody gap="medium" pad="medium">
          <TextArea
            placeholder={I18n.t('describeProblem')}
            value={feedback}
            onChange={onChangeFeedback}
            margin={{ horizontal: '10px' }}
            resize="vertical"
          />
          <Box flex>
            <LabelText>{I18n.t('emailId')}</LabelText>
            <TextInput
              flex
              value={emailId}
              placeholder={I18n.t('enterEmailIdForFeedback')}
              onChange={onChangeEmail}
            />
          </Box>
          <Text size="small" color="dark-4">
            {I18n.t('attachScreenshotsToFeedback')}
          </Text>
        </CardBody>
      </Card>
    </AppCanvas>
  )
}

export default ReportAProblem
